import { ChevronDown, ChevronUp, Dot } from 'lucide-react';
import { useState } from 'react';
import {
  Box,
  Flex,
  Heading,
  Text,
  Input,
  InputGroup,
  InputLeftElement,
  SimpleGrid,
  Button,
  Tag,
  Card,
  CardBody,
  Image,
  IconButton,
  useColorModeValue,
  Link
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

export const SidebarItem = ({ item, isCollapsed, activePath }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const isActive = (path) => activePath === path;
  const hasChildren = item.children && item.children.length > 0;

  return (
    <Box width="100%">
      {/* Parent */}
      <Flex
        onClick={() => hasChildren ? setIsExpanded(!isExpanded) : null}
        as={hasChildren ? 'div' : RouterLink}
        to={hasChildren ? undefined : item.path}
        align="center"
        justify={isCollapsed ? "center" : "flex-start"}
        py={2}
        px={3}
        borderRadius="md"
        _hover={{ bg: hasChildren ? 'gray.100' : 'gray.50' }}
        bg={isActive(item.path) ? "teal.50" : "transparent"}
        color={isActive(item.path) ? "teal.600" : "inherit"}
        cursor="pointer"
        mb={1}
        fontWeight={isActive(item.path) ? "bold" : "medium"}
      >
        <Box mr={isCollapsed ? 0 : 3}>
          {item.icon}
        </Box>
        {!isCollapsed && (
          <Flex flex="1" justify="space-between" align="center">
            <Text>{item.name}</Text>
            {hasChildren && (
              isExpanded ? <ChevronUp size={16} /> : <ChevronDown size={16} />
            )}
          </Flex>
        )}
      </Flex>

      {/* Children */}
      {hasChildren && isExpanded && !isCollapsed && (
        <Box pl={6}>
          {item.children.map((child) => (
            <Link
              as={RouterLink}
              to={child.path}
              key={child.name}
              py={1.5}
              px={3}
              display="flex"
              alignItems="center"
              gap={2}
              borderRadius="md"
              bg={isActive(child.path) ? "teal.50" : "transparent"}
              color={isActive(child.path) ? "teal.600" : "inherit"}
              _hover={{ bg: "gray.50" }}
              fontWeight={isActive(child.path) ? "bold" : "normal"}
            >
              {/* Icon */}
              <Box>
                {child.icon ? child.icon : <Dot size={18} />}
              </Box>
              <Text>{child.name}</Text>
            </Link>
          ))}
        </Box>
      )}
    </Box>
  );
};
